/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    {
      title: t('general.code'),
      field: 'id',
    },
    {
      title: t('general.date'),
      field: 'formattedDate',
    },
    {
      title: t('general.discipline'),
      field: 'subject.label',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.subject.label}>
          {rowData.subject.label}
        </span>
      ),
    },
    {
      title: t('general.school-class'),
      field: 'schoolClass.label',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.schoolClass.label}>
          {rowData.schoolClass.label}
        </span>
      ),
    },
    {
      title: t('general.subject'),
      field: 'workSubject',
    },
    {
      title: t('general.classes'),
      field: 'classes',
    },
  ];
}
